<div class="uk-flex uk-flex-center uk-flex-middle nav-large">
  <div *ngIf="!navOpen" class="uk-flex uk-flex-middle pointer nav-toggle" uk-toggle="target:#offcanvas">
    <fa-icon class="primary-color" icon="chevron-right"></fa-icon>
  </div>

  <div id="offcanvas" uk-offcanvas="mode: push; bg-close: false">
    <div class="uk-offcanvas-bar">
      <button class="uk-offcanvas-close" type="button" uk-close></button>

      <img class="logo uk-margin-large-top uk-margin-large-bottom" src="assets/images/deck_white.svg" alt="Dealflow logo" />

      <ul class="uk-nav uk-nav-default">
        <li>
          <a routerLink="/users" routerLinkActive="active" i18n="@@Users">Users</a>
        </li>

        <li>
          <a routerLink="/investment-companies" routerLinkActive="active" i18n="@@InvCompanies">Inv. companies</a>
        </li>

        <li>
          <a routerLink="/companies" routerLinkActive="active" i18n="@@Companies">Companies</a>
        </li>

        <li>
          <a routerLink="/pep-list" routerLinkActive="active" i18n="@@PEPList">PEP list</a>
        </li>

        <li>
          <a routerLink="/pitches" routerLinkActive="active" i18n="@@Pitches">Pitches</a>
        </li>

        <li>
          <a routerLink="/questions" routerLinkActive="active" i18n="@@Questions">Questions</a>
        </li>

        <li>
          <a routerLink="/analyses" routerLinkActive="active" i18n="@@Analyses">Analyses</a>
        </li>

        <li>
          <a routerLink="/subscriptions" routerLinkActive="active" i18n="@@Subscriptions">Subscriptions</a>
        </li>

        <li>
          <a routerLink="/investments" routerLinkActive="active" i18n="@@Investments">Investments</a>
        </li>

        <li>
          <a routerLink="/inquiries" routerLinkActive="active" i18n="@@ContactUs">Contact us</a>
        </li>

        <li>
          <a routerLink="/self-publishes" routerLinkActive="active" i18n="@@SelfPublishes">Self publishes</a>
        </li>

        <li>
          <a routerLink="/statistics" routerLinkActive="active" i18n="@@Statistics">Statistics</a>
        </li>

        <li>
          <a routerLink="/second-hand-market" routerLinkActive="active" i18n="@@SecondHandMarket">Second hand market</a>
        </li>

        <li>
          <a routerLink="/sp-access-requests" routerLinkActive="active" i18n="@@SPAccessRequests">SP Access Requests</a>
        </li>

        <li>
          <a routerLink="/tags" routerLinkActive="active" i18n="@@Tags">Tags</a>
        </li>

        <li class="logout">
          <a (click)="logout()" i18n="@@Logout">Logout</a>
        </li>
      </ul>

      <div class="login-info">
        <ng-container i18n="@@loggedAs">You are logged in as:</ng-container>
        <br />

        <ng-container *ngIf="!username.includes('@'); else email">
          {{ username | titlecase | namesWithDash }}
        </ng-container>

        <ng-template #email>
          {{ username.slice(0, username.indexOf('@')) }}
        </ng-template>
      </div>
    </div>
  </div>
</div>
